import { css } from '@emotion/core';
import { media, variables } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font;
export var bodyTextBold = /*#__PURE__*/css("font-weight:", font.headingFontWeight, ";");
export var gotItButton = {
  name: "9ri52l",
  styles: "width:170px;height:40px;margin-bottom:14px;"
};
export var resendActivationButton = /*#__PURE__*/css("font-size:", font.smallFontSize, ";color:", colour.neutral600, ";&:hover{color:", colour.neutral600, ";}");
export var title = /*#__PURE__*/css("font-family:", font.headingFontFamily, ";font-size:", font.h3FontSize, ";color:", colour.neutral700, ";font-weight:", font.headingFontWeight, ";line-height:1.27;margin:0 0 18px;text-align:center;margin-top:8px;", media('>=tablet'), "{margin:30px 0 18px;}");
export var signUpButton = {
  name: "y8aj3r",
  styles: "padding:0;"
};